import { render, staticRenderFns } from "./LegalMinimumWageExclusions.vue?vue&type=template&id=2d30e09e&scoped=true"
import script from "./LegalMinimumWageExclusions.vue?vue&type=script&lang=js"
export * from "./LegalMinimumWageExclusions.vue?vue&type=script&lang=js"
import style0 from "./LegalMinimumWageExclusions.vue?vue&type=style&index=0&id=2d30e09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30e09e",
  null
  
)

export default component.exports